/** "Perche lo chiedo": una frase sotto la domanda, stessa tinta del testo con meno peso. */
import type { ReactNode } from 'react'

export type WhyTextProps = {
  children: ReactNode
  id?: string
}

export function WhyText({ children, id }: WhyTextProps) {
  return (
    <p id={id} className="text-soft text-why text-ink">
      {children}
    </p>
  )
}
